'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sieve = require('../Sieve');

var _Sieve2 = _interopRequireDefault(_Sieve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sieve = function Sieve() {
  _classCallCheck(this, Sieve);

  var sieve = new _Sieve2.default();

  this.add = function (id, options) {
    sieve.add(id, options);
    return this;
  };

  this.remove = function (id) {
    sieve.remove(id);
    return this;
  };

  this.key = function (key) {
    if (!key) {
      return sieve.key(key);
    }
    sieve.key(key);
    return this;
  };

  this.sift = function (data, inputValues) {
    return sieve.sift(data, inputValues);
  };
};

exports.default = Sieve;
//# sourceMappingURL=Sieve.js.map
